export default __webpack_public_path__ + "static/media/addFeeWhite.981b7950.svg";